module.exports = __webpack_public_path__ + "static/hero-5bcb088a1b070a5810c70665d1afe1e3.jpg";